import axiosInstance from '../utils/axios';

interface LoginResponse {
  token: string;
}

interface LoginCredentials {
  username: string;
  password: string;
}

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await axiosInstance.post<LoginResponse>('/api/Auth/login', credentials);
  return response.data;
};

export const register = async (userData: any) => {
  const response = await axiosInstance.post('/api/Auth/register', userData);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
};